import { getActiveChain, getExplorerTxPrefix, getContractAddress } from "../config/chains";
import axios from "axios";

export const API_URL = process.env.REACT_APP_API_URL;
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
export const CURRENCY = process.env.REACT_APP_CURRENCY || "USDC";
// BUG-51 fix: destructuring `([first, ...rest])` throws immediately for
// undefined/null (nothing to destructure), and even for an empty string
// `first` is undefined so `.toLocaleUpperCase()` still throws — a missing
// or blank field (e.g. an empty planName) used to crash whatever page
// called this instead of just rendering nothing.
export const UCASE = (value, locale = navigator.language) => {
  if (typeof value !== "string" || value.length === 0) return "";
  const [first, ...rest] = value;
  return first.toLocaleUpperCase(locale) + rest.join("");
};




// DEPRECATED (EEG/SUBSCRIBE/USDC/MARKETPLACE address constants below): fixed at
// load time (the chain active then) and they ignore later network switches. Use
// getContractAddress("eeg" | "subscribe" | "usdc" | "marketplace") from
// config/chains.js, which resolves per chain at call time.
const EEG_TOKEN_ADDRESS = getContractAddress("eeg");

const SUBSCRIBE_TOKEN_ADDRESS = getContractAddress("subscribe");

// Must match the backend's USDC_TOKEN_51 (backend/config/payment.js) — this
// is the ERC20 the escrow module's contribute()/approve() flow actually
// pulls from. It's baked into each property's escrow module at deployment
// time (see deployPropertyEscrow in backend/config/escrow.js), so it can't
// drift from that value without breaking every contribution on-chain.
const USDC_TOKEN_ADDRESS = getContractAddress("usdc");

// Deployed contracts/marketplace/SecondaryMarketplace.sol address — set
// this once you've compiled/deployed it via Remix (same value as the
// backend's MARKETPLACE_CONTRACT_ADDRESS in backend/.env, since both sides
// talk to the same contract).
const MARKETPLACE_CONTRACT_ADDRESS = getContractAddress("marketplace");

// DEPRECATED: static, so it can't follow a network switch. Use
// getExplorerTxUrl()/getExplorerTxPrefix() from config/chains.js instead.
export const REACT_APP_EXPLORER_URL =
  process.env.REACT_APP_EXPLORER_URL || getExplorerTxPrefix();

export const DUMMY_PROPERTY_IMAGE = process.env.PUBLIC_URL + "/building.png";

export const uploadFileServer = async (data) => {
  try {
    var response = await axios.post(`/upload/s3`, data);
    return response.data.file;
  } catch (err) {
    return null;
  }
};

const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

export const getTxnStatus = async (txHash, provider) => {
  let transactionReceipt = null;
  while (transactionReceipt == null) {
    // Waiting expectedBlockTime until the transaction is mined
    transactionReceipt = await provider.getTransactionReceipt(txHash);
    await sleep(3000);
  }
  if (transactionReceipt.status) {
    return [txHash, true];
  } else {
    return [txHash, false];
  }
};

export const trimString = (str, length = 50) => {
  // BUG-51 fix: `str.length` threw for undefined/null — a field that
  // simply hadn't loaded yet (or was never provided) crashed the page
  // instead of rendering as empty text.
  if (typeof str !== "string") return "";
  if (str.length > length) {
    return str.substring(0, length) + "...";
  }
  return str;
};

// Derived from the chain registry (config/chains.js) — the chain active at
// load time. Only Magic's network config still needs this static shape.
const _bootChain = getActiveChain();
const customNodeOptions = {
  rpcUrl: _bootChain.rpcUrl,
  chainId: _bootChain.chainId,
  networkName: _bootChain.name,
};

export const getPlanBgClass = (planName) => {
  if (!planName) return "ag-courses-item_bg_gray";
  switch (planName) {
    case "Standard Member":
      return "ag-courses-item_bg_blue";
    case "Gold Member":
      return "ag-courses-item_bg_gold";
    case "Platinum Member":
      return "ag-courses-item_bg_teal";
    default:
      return "ag-courses-item_bg_gray";
  }
};

export const getPlanBgClassDate = (planName) => {
  if (!planName) return "ag-courses-item_date_bg-gray";
  switch (planName) {
    case "Standard Member":
      return "ag-courses-item_date_bg-blue";
    case "Gold Member":
      return "ag-courses-item_date_bg-gold";
    case "Platinum Member":
      return "ag-courses-item_date_bg-teal";
    default:
      return "ag-courses-item_date_bg-gray";
  }
};

export const getPlanButtonClass = (planName) => {
  if (!planName) return "btn-grey";
  switch (planName) {
    case "Standard Member":
      return "btn-basic";
    case "Gold Member":
      return "btn-gold";
    case "Platinum Member":
      return "btn-premium";
    default:
      return "btn-none";
  }
};

const PLAN_LEVELS = {
  "Standard Member": 1,
  "Gold Member": 2,
  "Platinum Member": 3,
};

const getPlanLevel = (planName) =>
  PLAN_LEVELS[planName] !== undefined ? PLAN_LEVELS[planName] : 0;


export const canChoosePlan = ({
  currentPlanName,
  currentExpired,
  targetPlanName,
}) => {
  if (currentExpired) return true;
  return getPlanLevel(targetPlanName) >= getPlanLevel(currentPlanName);
};